'use client';
import React from 'react';
import { CallToAction, CloseContainer } from '@benzinga/ui';
import { selectCampaignTargets } from '../../utils/targeting';
import { isMobile } from '@benzinga/device-utils';
import { Impression, useGeo } from '@benzinga/analytics';
import { getScrollRevealShellClassName } from './scrollRevealShellClassName';
import { useScrollReveal } from './useScrollReveal';

export interface FloatingPopupProps {
  campaign?: any;
  targets: any[];
}

export const FloatingPopup: React.FC<FloatingPopupProps> = ({ campaign, targets }) => {
  const [currentCampaign, setCurrentCampaign] = React.useState(campaign);
  const geo = useGeo();
  const { handleOnClose, isRevealed } = useScrollReveal();

  React.useEffect(() => {
    if (geo === null) return;
    const options = selectCampaignTargets(targets, geo, isMobile());
    const placement = options['floating'];
    setCurrentCampaign(placement?.campaign);
  }, [geo, targets]);

  React.useEffect(() => {
    if (!currentCampaign) {
      const options = selectCampaignTargets(targets, global.geo, isMobile());
      const placement = options['floating'];
      setCurrentCampaign(placement?.campaign);
    }
  }, [currentCampaign, targets]);

  // If no campaign
  if (!currentCampaign) {
    return <div />;
  }

  return (
    <div className={getScrollRevealShellClassName(isRevealed, 'default')}>
      <Impression
        campaign_id={currentCampaign.id ?? currentCampaign.utm_action}
        tag={currentCampaign.impression_tag}
        unit_type="Floating CTA"
      >
        <CloseContainer onClose={handleOnClose}>
          <CallToAction
            button_text={currentCampaign.cta_text}
            description={currentCampaign.cta_description}
            disclosure={currentCampaign.disclosure}
            go_link_dofollow={currentCampaign?.go_link_dofollow}
            id={currentCampaign.id}
            image_url={currentCampaign.image_url}
            image_width={currentCampaign?.image_width}
            layout="floating"
            show_bz_badge={true}
            title={currentCampaign.cta_title}
            url={currentCampaign.url}
            utm_action={currentCampaign.utm_action ? currentCampaign.utm_action : currentCampaign.cta_title}
            utm_category="Lead Click"
            utm_label="Floating CTA"
          />
        </CloseContainer>
      </Impression>
    </div>
  );
};
